import { generateClient } from "aws-amplify/api";
import { batchAddFieldTemplates } from "../graphql/mutations";
import { FieldTemplateForResolver } from "db/definitions";
import { recordSentry } from "utils/recordSentry";

async function batchCreateFieldTemplates(fieldTemplates: FieldTemplateForResolver[]): Promise<boolean> {
	if (fieldTemplates.length > 0) {
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchAddFieldTemplates,
				variables: { fieldTemplates: fieldTemplates },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			recordSentry({ error });
		}
		return false;
	}
	return true;
}

export default batchCreateFieldTemplates;
